<template>
    <div class="rounded-md shadow-sm">
        <button
            class="flex w-full justify-center py-2 px-4 text-sm font-medium rounded-md border | focus:outline-none | transition duration-150 ease-in-out"
            :class="{
                'bg-blue-500 border-transparent text-white | hover:bg-blue-400 | focus:border-blue-700 focus:shadow-outline-blue | active:bg-blue-700': primary,
                'bg-white border-gray-300 text-gray-700 | hover:bg-gray-100 | focus:border-blue-300 focus:shadow-outline-blue | active:bg-gray-50 active:text-gray-800': !primary,
                'opacity-50 cursor-not-allowed hover:bg-blue-500': disabled,
            }"
            :disabled="disabled"
            ref="button"
            @click.prevent="$emit('click')"
        >
            <slot />
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            primary: {
                type: Boolean,
                default: true,
            },
        },

        methods: {
            async focus() {
                await this.$nextTick();

                this.$refs.button.focus();
            },
        },
    };
</script>
